import { flow } from "fp";
import { QueryKey } from "react-query";

import { ID, Reference } from "~/Data";
import * as Data from "~/Data";
import * as Log from "~/Log";
import { Request } from "~/Request";
import { Time } from "~/Time";

export const toEndpoint = ({ id, interval }: Query.QueryParams) =>
  `/elogs/drivers/${id}/audit-log?start_date=${Time.DateTime.toISO(
    interval.start
  )}&end_date=${Time.DateTime.toISO(interval.stop)}`;

export namespace Query {
  export const tag = () => "Audit Logs" as const;

  export type QueryKeyParams = {
    readonly id: ID.ID;
  };

  export type QueryParams = Reference.Reference & Time.Interval.Stopped;

  export const id = ({ driver, dateTime }: Log.Identity): ID.ID =>
    `${driver.id}-${Time.DateTime.toISOWithoutTime({ dateTime })}`;

  export const key = (id: QueryKeyParams): QueryKey => [tag(), id];

  export type RequestProps = {
    readonly driver: Data.Reference.Reference;
    readonly startTime: Time.DateTime;
    readonly stopTime: Time.DateTime;
  };
  export const request = ({
    driver,
    startTime,
    stopTime,
  }: RequestProps): Request.Fn<Log.Audit.Audit> => {
    const requestInterval = Time.Interval.Stopped.fromDateTimes(
      startTime,
      stopTime
    );
    const endpoint = toEndpoint({ id: driver.id, ...requestInterval });
    return flow(
      Request.fromConfig({ endpoint }),
      Request.Expect.status(200),
      Request.Expect.json(Log.Audit.Response.runtime()),
      Request.onSuccess(Log.Audit.Response.decode(driver))
    );
  };
}
